module.exports = __webpack_public_path__ + "static/img/product08.a15cc1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product08.png
// module id = PIPB
// module chunks = 1